module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/03aed75f9a75aef179982d359433dea4.svg";